import { Component, inject,  OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AutoLogoutService } from './core/services/auth/auto-logout.service';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';
import { isPlatformBrowser } from '@angular/common';
import { OfflineBannerComponent } from './shared/components/offline-banner/offline-banner.component';
import { SessionExpiredBannerComponent } from './shared/components/session-expired-banner/session-expired-banner.component';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet, TranslateModule, OfflineBannerComponent, SessionExpiredBannerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private autoLogoutService = inject(AutoLogoutService);
  private router = inject(Router);

  languages = ['fr', 'en'];
  private translateService = inject(TranslateService)
  private platformId = inject(PLATFORM_ID);

  async ngOnInit(): Promise<void> {
    const defaultLanguage = localStorage.getItem('language') || 'fr';
    this.translateService.setDefaultLang(defaultLanguage);
    this.translateService.use(defaultLanguage);
    this.autoLogoutService.startMonitoring();

    // Initialize Capacitor plugins for mobile
    if (isPlatformBrowser(this.platformId) && Capacitor.isNativePlatform()) {
      await this.initializeCapacitor();
    }
  }

  private async initializeCapacitor(): Promise<void> {
    try {
      // Configure Status Bar
      if (Capacitor.isPluginAvailable('StatusBar')) {
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.setBackgroundColor({ color: '#30a8dc' });
      }

      // Configure Keyboard
      if (Capacitor.isPluginAvailable('Keyboard')) {
        Keyboard.setAccessoryBarVisible({ isVisible: true });
      }

      // Handle app state changes
      if (Capacitor.isPluginAvailable('App')) {
        App.addListener('appStateChange', ({ isActive }) => {
          if (isActive) {
            console.warn('App has come to the foreground!');
          } else {
            console.warn('App has gone to the background!');
          }
        });

        // Handle back button on Android
        App.addListener('backButton', ({ canGoBack }) => {
          if (!canGoBack) {
            App.exitApp();
          } else {
            window.history.back();
          }
        });

        App.addListener('appUrlOpen', ({ url }) => {
          try {
            const parsed = new URL(url);
            const path = (parsed.host ? '/' + parsed.host : '') + parsed.pathname + parsed.search;
            if (path) this.router.navigateByUrl(path);
          } catch {
            console.error('appUrlOpen: invalid URL', url);
          }
        });
      }
    } catch (error) {
      console.error('Error initializing Capacitor plugins:', error);
    }
  }

  changeLanguage(language : string){
    this.translateService.use(language);
    localStorage.setItem('language', language);
  }
}

